<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <coupon-form ref="form" v-model="form" :input-errors="inputErrors" @save="update"/>
  </crud-update>
</template>

<script>

import CouponProvider from "../../../../providers/CouponProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import CouponForm from "../../../../forms/CouponForm";

import {Dayjs} from "@dracul/dayjs-frontend";

export default {
  name: "CouponUpdate",

  components: {CouponForm, CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'delivery.coupon.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        code: this.item.code,
        description: this.item.description,
        discountType: this.item.discountType,
        discountValue: this.item.discountValue,
        minimumOrderAmount: this.item.minimumOrderAmount,
        startDate: this.item.startDate ? Dayjs(parseInt(this.item.startDate)) : null,
        expirationDate: this.item.expirationDate ? Dayjs(parseInt(this.item.expirationDate)) : null,
        maxTotalUses: this.item.maxTotalUses,
        active: this.item.active,
        paymentMethods: this.item.paymentMethods ? this.item.paymentMethods : []
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        CouponProvider.updateCoupon(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updateCoupon)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }
  },
}
</script>

<style scoped>

</style>

